import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { HOBBIES_INTERESTS_OPTIONS } from '@/pages/Onboarding/options/HobbiesInterests/HOBBIES_INTERESTS_OPTIONS';
import { getHobbiesInterestsTitleById } from '@/pages/Onboarding/options/HobbiesInterests/utils/getHobbiesInterests';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const HobbiesInterestsScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'HobbiesInterests',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const hobbiesInterests = form.watch('hobbies_interests');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['hobbies_interests']>,
  ) => {
    form.setValue('hobbies_interests', option.id);
  };

  const handleNextStep = () => {
    const hobbiesInterestsTitle =
      getHobbiesInterestsTitleById(hobbiesInterests);

    userService.createOrUpdate({
      onboarding_data: {
        hobbies_interests: hobbiesInterestsTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>What Are His Hobbies & Interests?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="grid-with-icon">
          {HOBBIES_INTERESTS_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={hobbiesInterests === option.id}
              control={form.control}
              option={option}
              name="hobbies_interests"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="grid-with-icon"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!hobbiesInterests}
      />
    </OnboardingPage>
  );
};
